/**
 * Created by Ivan on 23.03.2025
 */

const ScoreBar = function (savedInfo) {
    cleverapps.EventEmitter.call(this);

    this.stage = 0;
    this.total = 0;
    this.currentPoints = Game.currentGame.score.getPoints();
    this.currentGoal = Game.currentGame.calcScoreBarGoal(this.stage);

    this.createPlayers();

    while (this.currentPoints >= this.currentGoal) {
        this.currentPoints -= this.currentGoal;
        this.total += this.currentGoal;
        this.currentGoal = Game.currentGame.calcScoreBarGoal(++this.stage);
    }

    this.updatePoints();

    this.prize = this.choosePrize(savedInfo);

    Game.currentGame.score.on("onUpdate", this.updatePoints.bind(this));
};

ScoreBar.prototype = Object.create(cleverapps.EventEmitter.prototype);
ScoreBar.prototype.constructor = ScoreBar;

ScoreBar.prototype.createPlayers = function () {
    this.players = cleverapps.bots.listBots(ScoreBar.PLAYERS_AMOUNT);

    this.user = {
        id: connector.platform.getUserID(),
        name: cleverapps.user.getPlayerInfo().name,
        avatar: cleverapps.user.getPlayerInfo().avatar,
        user: true
    };

    cleverapps.UI.Avatar.preload(this.players.concat([this.user]));
};

ScoreBar.prototype.getPlayer = function () {
    return this.players[this.stage % ScoreBar.PLAYERS_AMOUNT];
};

ScoreBar.prototype.getInfo = function () {
    return {
        prize: this.prize.id
    };
};

ScoreBar.prototype.choosePrize = function (savedInfo) {
    if (savedInfo && savedInfo.prize) {
        return ScoreBar.PRIZES[cleverapps.config.type].find((prize) => prize.id === savedInfo.prize);
    }

    return PseudoRandom.GET().choose(ScoreBar.PRIZES[cleverapps.config.type].slice().map(
        (reward) => cleverapps.arrayFill(reward.probability || 1, reward)
    ).flat());
};

ScoreBar.prototype.isStageCompleted = function () {
    return this.currentPoints >= this.currentGoal;
};

ScoreBar.prototype.showControls = function () {
    const boostersButtons = cleverapps.boosters.listBoosters().filter((booster) => booster.isAvailable()).map((button) => button.getControlId());
    cleverapps.focusManager.showControlsWhileFocused(boostersButtons.concat(["cookieJar"]));
};

ScoreBar.prototype.calcPercent = function () {
    return Math.min(1, this.currentPoints / this.currentGoal);
};

ScoreBar.prototype.nextStage = function () {
    cleverapps.focusManager.display({
        focus: "ScoreBarRewardWindow",
        stack: true,
        actions: [
            function (f) {
                this.movingNextStage = true;
                Game.currentGame.counter.inc();
                f();
            }.bind(this),

            function (f) {
                this.showControls();
                f();
            }.bind(this),

            function (f) {
                this.trigger("completeStage", true);
                cleverapps.timeouts.setTimeout(f, 1500);
            }.bind(this),
         
            function (f) {
                if (connector.ads.isRewardedSupported && cleverapps.adsLimits.state(AdsLimits.TYPES.SCORE_BAR) === AdsLimits.STATE_READY) {
                    new ScoreBarRewardWindow({
                        image: this.prize.image,
                        avatar: true,
                        onAccept: () => {
                            this.prize.receive(f);
                            cleverapps.metrics.logEvent(cleverapps.EVENTS.SCORE_BAR_ACCEPT_REWARD);
                        },
                        onReject: f
                    });
                } else {
                    this.prize.receive(f);
                }
            }.bind(this),

            function (f) {
                this.stage++;
                this.total += this.currentGoal;
                cleverapps.metrics.logEvent(cleverapps.EVENTS.SCORE_BAR_COMPLETE_STAGE);

                this.currentGoal = Game.currentGame.calcScoreBarGoal(this.stage);

                this.currentPoints = Game.currentGame.score.getPoints() - this.total;

                this.trigger("updateStage");

                this.prize = this.choosePrize();

                cleverapps.timeouts.setTimeout(f, 1200);
            }.bind(this),

            function (f) {
                this.movingNextStage = false;
                Game.currentGame.counter.dec();
                f();
            }.bind(this)
        ]
    });
};

ScoreBar.prototype.updatePoints = function () {
    this.currentPoints = Game.currentGame.score.getPoints() - this.total;
    this.trigger("updatePoints");
};

ScoreBar.PRIZES = {
    blocks:
    [
        {
            id: "clear_pieces_booster",
            image: bundles.game.frames.bomb_prize_png,
            receive: function (cb) {
                Game.currentGame.grid.runClearBang(cb);
            },
            probability: 1
        },
        {
            id: "change_piece",
            image: bundles.game.frames.blocks_prize_png,
            receive: function (cb) {
                Game.currentGame.pieces.replaceToBonus(cb);
            },
            probability: 2
        },
        {
            id: "gravity_effect",
            image: bundles.game.frames.gravity_prize_png,
            receive: function (cb) {
                cleverapps.persist.acceptNode("ScoreBarAvatar");
                Game.currentGame.grid.dropCells(cb);
            },
            probability: 2
        }
    ],
    board: [
        {
            id: "hint_booster",
            image: bundles.reward_icons.frames.hint_icon_png,
            receive: function (cb) {
                const hintBooster = cleverapps.boosters.getBoosterById(cleverapps.Boosters.TYPE_HINT);
                hintBooster.onExecute();
                cb();
            },
            probability: 1
        }
    ]
};

ScoreBar.isAvailable = function () {
    return cleverapps.user.checkAvailable(cleverapps.config.availables.SCORE_BAR);
};

ScoreBar.PLAYERS_AMOUNT = 20;